import { usePaymentModalData } from "@faire/deprecated-retailer-visitor-shared/components/PromoModals/hooks/usePaymentModalData";
import { usePromoModalContextStore } from "@faire/deprecated-retailer-visitor-shared/stores/ui/PromoModalContextStore";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { useCallback } from "react";

import { useAllEnabledModalTypes } from "./useAllEnabledModalTypes";
import { useGetHighestPriorityModalType } from "./useGetHighestPriorityModalType";

const useModalToDisplay = (): PromoModalType | null => {
  const promoModalTypes = useAllEnabledModalTypes();
  const { getHighestPriorityModalType } = useGetHighestPriorityModalType();

  const highestPriorityModalType = getHighestPriorityModalType(promoModalTypes);

  return highestPriorityModalType ?? null;
};

// Don't export this to UI code, because it's not safe to use storage in SSR.
// Create wrapper hooks instead.
export const usePromoModalStore = () => {
  const [, setStore] = usePromoModalContextStore([]);

  const { data: paymentModalData, isFetching: isPaymentModalDataFetching } =
    usePaymentModalData();

  const modalType = paymentModalData?.promo_modal_information?.type;

  const modalToDisplay = useModalToDisplay();
  const closeModal = useCallback(() => {
    setStore({
      hasUserClosedModal: true,
    });
  }, [setStore]);

  // Conductor is client driven so it doesn't yet have a corresponding modal type
  // We are overriding it here until we have an endpoint for modals so we can
  // cleanup the serialized data
  const isProtectedForNewRetailer =
    modalType === PromoModalType.PROTECTED_FOR_NEW_RETAILER &&
    modalToDisplay !== PromoModalType.CONDUCTOR_MODAL;

  return {
    modalToDisplay:
      isPaymentModalDataFetching ||
      modalType === undefined ||
      isProtectedForNewRetailer
        ? null
        : modalToDisplay,
    closeModal,
  };
};
